module.exports = __webpack_public_path__ + "img/emoji_34.666226a5.png";